import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: null, // Initial state for authentication
  user: null, // Store user data when authenticated
  formType: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload; // Store user data
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
    },
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
    setFormType: (state, action) => {
      state.formType = action.payload;
    },
  },
});

export const {
  login,
  logout,
  setUser,
  clearUser,
  setFormType,
} = authSlice.actions;

export default authSlice;
